import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TableHeaderRow = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          d="M7.5 2H14c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H2a1 1 0 0 1-1-1V3c0-.6.4-1 1-1h5.5ZM14 6v3H8.5V6H14ZM7.5 6v3H2V6h5.5Zm0 4H2v3h5.5v-3Zm6.5 0H8.5v3H14v-3Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default TableHeaderRow
